import _ from "lodash"
import { responsiveCSSStyle } from "./styles"
import colors from "./styleColors"

/**
 * Override property of one xAxis item
 * See API doc: https://api.highcharts.com/highstock/xAxis
 * @param xAxix
 */
function applyXAxisPlugin(xAxix) {
  _.unset(xAxix, "gridLineColor")
  _.unset(xAxix, "gridLineWidth")

  _.set(xAxix, "dateTimeLabelFormats", { month: "%m/%Y" })
  _.set(xAxix, "labels.rotation", -45)
  _.set(xAxix, "labels.style", responsiveCSSStyle())

  _.set(xAxix, "lineColor", colors.axisLineColor)
  _.set(xAxix, "lineWidth", 1)
  _.set(xAxix, "tickColor", colors.axisLineColor)
}

/**
 * Custom xAxis
 * See API doc: https://api.highcharts.com/highstock/xAxis
 * @param chartOpts
 * @returns {*}
 */
export default function xAxisPlugin(chartOpts) {
  if (!chartOpts.xAxis) {
    return chartOpts
  }

  if (_.isArray(chartOpts.xAxis)) {
    chartOpts.xAxis.forEach(applyXAxisPlugin)
    return chartOpts
  }
  // simple axis apply
  applyXAxisPlugin(chartOpts.xAxis)
  return chartOpts
}
